export const MESSAGE_STANDARD_INFO = 'Hello, welcome to our Bill Pay Customer Service online chat. ' +
    'I would like to mention that the chat is monitored and recorded for quality assurance. ' +
    'If you have general questions about Ballad Health or would like to schedule, ' +
    'reschedule an appointment, or have questions regarding your MyChart account please <a href="https://www.balladhealth.org/contact">click here</a>.';

export const MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT = "We're very sorry, but all of our agents are assisting other patients " +
    "right now. Please try again in a few minutes or visit <a href='https://www.balladhealth.org/contact'>" +
    "Contact Us | Ballad Health</a> for additional options to service your account.";

export const QUEUE_NAME_BAH_BALLAD_HEALTH_CS = 'Ballad - CS';

export const QUEUE_TYPE_DEFAULT = 0;
